import http from "@/api/http";

export default {
  postNewAddress(data) {
    return http({ url: "/user/address", method: "post", data: data });
  },
  primaryAddress(idAddress) {
    return http({
      url: "/user/address/primary",
      method: "post",
      data: { id: idAddress }
    });
  },
  postdeleteAddress(idAddress) {
    return http({
      url: "/user/address/delete",
      method: "post",
      data: { id: idAddress }
    });
  },
  updateAddress(data) {
    return http({ url: "/user/address/update", method: "post", data: data });
  }
};
